'use client';

import { pushGTMEvent, pushGTMEventForATM } from '@/utils/gtm';
import { DirectionsIcon } from '@/public/assets/svg';
import LinkButton from '../..';
import { DirectionsLinkButtonProps } from './types';
const DirectionsLinkButton = ({
  eventName,
  eventType,
  additionalParams,
  location,
  ...rest
}: DirectionsLinkButtonProps) => {
  const ChildComponent = ({
    label,
    ...rest
  }: DirectionsLinkButtonProps) => {
    return <LinkButton className="order-2 col-span-2 whitespace-nowrap lg:order-3" variant="secondary" href={location?.googleMapUrl} {...rest} data-sentry-element="LinkButton" data-sentry-component="ChildComponent" data-sentry-source-file="index.tsx">
        <DirectionsIcon className="mr-2 min-h-5 min-w-5 text-white" data-sentry-element="DirectionsIcon" data-sentry-source-file="index.tsx" /> {label}
      </LinkButton>;
  };
  if (!eventName) {
    return <ChildComponent {...rest} />;
  }
  switch (eventType) {
    case 'atm':
      if (!location) {
        return <ChildComponent {...rest} />;
      }
      return <ChildComponent {...rest} onClick={() => pushGTMEventForATM(location, eventName)} />;
    default:
      return <ChildComponent onClick={() => pushGTMEvent({
        event: eventName,
        ...additionalParams
      })} {...rest} />;
  }
};
export default DirectionsLinkButton;